export const NORMAL = 'N';
export const HIGH = 'H';